import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import strings from "../../helpers/Localization";

const TooltipGraphBarComposed = ({ payload, labelTooltip, subsections, fills }) => {

    const formatDateTooltip = (inputDate) => {
        const date = new Date(inputDate);

        const dateFormated = dayjs(date).format("DD.MM.YYYY");
        return dateFormated !== "Invalid Date" ? dateFormated : null;
    };

    const getInterruptTranslation = (interruptType) => {
        switch (interruptType) {
            case "NominalCallInterrupted" : return strings.Failed;
            case "NominalCallNotAnswered" : return strings.NotAnswered;
            case "NominalCallCancelledWithPortalInPaused": return "Intercom en anbsence";
            case "NominalCallCancelledWithPortalUnavailable": return "Aucun intercom disponible";
            default: return interruptType;
        }
    };


    let sum = 0;
    if (payload) {
        subsections.forEach(s => {
            sum += payload[s];
        });
        const formattedDate = formatDateTooltip(payload.name);
        return (
            <div className="tooltip-graph-bar-composed">
                <div className="header-tooltip-graph-bar-composed">
                    { formattedDate ? <p>{"Date "}<span>{formattedDate}</span></p> : null}
                    <p>{"Total "}<span>{`${sum} ${labelTooltip}`}</span></p>
                </div>
                <span style={{ width: "100%", height: "1px", backgroundColor: "var(--white)", opacity: 0.2, marginTop: "4px", marginBottom: "2px" }}/>
                {
                    subsections.map((s, index) => {
                        const subtext = payload.subdatas ? payload.subdatas[s] : "";
                        return <div key={index} className="module-graph-bar-composed">
                            <div id="cercle-graph-bar-composed" style={{ backgroundColor: fills[index] }}></div>
                            <p>
                                <span className="label-module-graph-bar-composed">{getInterruptTranslation(s)}</span>
                                <span className="value-module-graph-bar-composed">{payload[s] + " " + subtext}</span>
                            </p>
                        </div>;
                    })
                }
            </div>
        );
    }
    return null;
};

export default TooltipGraphBarComposed;
